// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"skeleton_skeleton__2Hc9i","skeleton-loading":"skeleton_skeleton-loading__3kKIS","skeleton__circle":"skeleton_skeleton__circle__3AzBL"};